export const GET_BUYER_SUPPLIER = 'GET_BUYER_SUPPLIER';
export const GET_BUYER_SUPPLIER_SUCCESS = 'GET_BUYER_SUPPLIER_SUCCESS';
export const GET_BUYER_SUPPLIER_FAILED = 'GET_BUYER_SUPPLIER_FAILED';

export const ADD_BUYER_SUPPLIER = 'ADD_BUYER_SUPPLIER';
export const ADD_BUYER_SUPPLIER_SUCCESS = 'ADD_BUYER_SUPPLIER_SUCCESS';
export const ADD_BUYER_SUPPLIER_FAILED = 'ADD_BUYER_SUPPLIER_FAILED';

export const EDIT_BUYER_SUPPLIER = 'EDIT_BUYER_SUPPLIER';
export const EDIT_BUYER_SUPPLIER_SUCCESS = 'EDIT_BUYER_SUPPLIER_SUCCESS';
export const EDIT_BUYER_SUPPLIER_FAILED = 'EDIT_BUYER_SUPPLIER_FAILED';

export const DELETE_BUYER_SUPPLIER = 'DELETE_BUYER_SUPPLIER';
export const DELETE_BUYER_SUPPLIER_SUCCESS = 'DELETE_BUYER_SUPPLIER_SUCCESS';
export const DELETE_BUYER_SUPPLIER_FAILED = 'DELETE_BUYER_SUPPLIER_FAILED';

export const BULK_DELETE_BUYER_SUPPLIER = 'BULK_DELETE_BUYER_SUPPLIER';
export const BULK_DELETE_BUYER_SUPPLIER_SUCCESS = 'BULK_DELETE_BUYER_SUPPLIER_SUCCESS';
export const BULK_DELETE_BUYER_SUPPLIER_FAILED = 'BULK_DELETE_BUYER_SUPPLIER_FAILED';

export const BULK_UPLOAD_BUYER_SUPPLIER = 'BULK_UPLOAD_BUYER_SUPPLIER';
export const BULK_UPLOAD_BUYER_SUPPLIER_SUCCESS = 'BULK_UPLOAD_BUYER_SUPPLIER_SUCCESS';
export const BULK_UPLOAD_BUYER_SUPPLIER_FAILED = 'BULK_UPLOAD_BUYER_SUPPLIER_FAILED';

export const GET_COMPANY_DETAILS_BY_GSTN = 'GET_COMPANY_DETAILS_BY_GSTN';
export const GET_COMPANY_DETAILS_BY_GSTN_SUCCESS = 'GET_COMPANY_DETAILS_BY_GSTN_SUCCESS';
export const GET_COMPANY_DETAILS_BY_GSTN_FAILED = 'GET_COMPANY_DETAILS_BY_GSTN_FAILED';